import React from 'react';
import Icon from '../../../components/AppIcon';

const DocumentCategoryCard = ({ category, onClick }) => {
  const getColorClasses = (color) => {
    const colors = {
      emerald: 'bg-emerald-50 border-emerald-200 hover:bg-emerald-100 text-emerald-700',
      blue: 'bg-blue-50 border-blue-200 hover:bg-blue-100 text-blue-700',
      purple: 'bg-purple-50 border-purple-200 hover:bg-purple-100 text-purple-700',
      amber: 'bg-amber-50 border-amber-200 hover:bg-amber-100 text-amber-700',
      indigo: 'bg-indigo-50 border-indigo-200 hover:bg-indigo-100 text-indigo-700',
      red: 'bg-red-50 border-red-200 hover:bg-red-100 text-red-700',
      cyan: 'bg-cyan-50 border-cyan-200 hover:bg-cyan-100 text-cyan-700',
      green: 'bg-green-50 border-green-200 hover:bg-green-100 text-green-700',
      pink: 'bg-pink-50 border-pink-200 hover:bg-pink-100 text-pink-700',
      gray: 'bg-gray-50 border-gray-200 hover:bg-gray-100 text-gray-700'
    };
    return colors?.[color] || 'bg-gray-50 border-gray-200 hover:bg-gray-100 text-gray-700';
  };

  return (
    <button
      onClick={onClick}
      className={`rounded-lg border p-4 text-left transition-all cursor-pointer ${getColorClasses(category?.color)}`}
    >
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0">
          <Icon name={category?.icon} size={24} />
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="font-semibold text-sm mb-1">{category?.label}</h4>
          <p className="text-xs opacity-80">{category?.description}</p>
        </div>
      </div>
    </button>
  );
};

export default DocumentCategoryCard;